<template>
    <el-dropdown popper-class="custom-dropdown-new" :show-arrow="false"
        @visible-change="(v: boolean) => { dropdownOpen = v; $emit('visibleChange', v) }">
        <span class="text-16 inline-flex items-center gap-4px">
            {{ t('common.about') }}
            <icon-svg-arrow-down class="w-12 h-12 transition-transform duration-200" :class="{ 'rotate-180': dropdownOpen }" />
        </span>
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item v-for="(item, idx) in dropdownList" :key="idx"
                    :class="{ active: matchPath(currentPath, item.path || '') }" @click="$emit('jumpPage', item)">
                    <span class="text-14 mb-4 !font-500 text-[rgba(8,8,8,0.9)]">{{ t(item.name) }}</span>
                    <span class="text-12 whitespace-normal !text-[rgba(8,8,8,0.50)] !font-400">
                        {{ t(item.desc) }}
                    </span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { menuList } from '@/layout/menuData';

defineEmits<{
    (e: 'visibleChange', visible: boolean): void;
    (e: 'jumpPage', child: (typeof menuList)[0]['dropdownList'][0]): void;
}>();

const { t } = useI18n();
const dropdownOpen = ref(false);
const route = useRoute();

const currentPath = computed(() => route.path);

const dropdownList = menuList.find(m => m.name === 'common.about')!.dropdownList!;

const matchPath = (path: string, targetPath: string): boolean => {
    if (!path || !targetPath) return false;
    return path.toLowerCase().indexOf(targetPath.toLowerCase()) >= 0;
};
</script>

<style lang="scss">
.custom-dropdown-new {
    .el-dropdown-menu__item {
        position: relative;
        padding-right: 32px;

        > span:first-child::after {
            content: '→';
            position: absolute;
            right: 12px;
            font-size: 14px;
            line-height: normal;
            color: #3846fa;
            opacity: 0;
            transform: translateX(-4px);
            transition: 0.18s ease;
        }

        &:hover > span:first-child::after {
            opacity: 1;
            transform: translateX(0);
        }
    }
}
</style>